import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsPersisted } from 'state/workspaces/workspace.actions';

export function deleteTabsDescriptionOnAllTabsRemovedEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('WORKSPACE_TABS_ALL_REMOVED'),
      mergeMap(action => {
        const api$ = tabsApiConnector(httpClient, action.workspace);
        return api$.clearAllTabDescriptions().pipe(
          map(() => workspaceTabsPersisted({ tabs: [] }, action.workspace)),
          catchError((_: Error) => {
            return EMPTY;
          }),
        );
      }),
    );
}
